// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3kdqZ","info":"Note_info__2KNXT","note":"Note_note__3nWFQ","actions":"Note_actions__1OBrr"};